import { intl } from './intlSetup'

function createIntlMiddleware() {
  return () => next => action => {
    return next({ ...action, intl })
  }
}

export default createIntlMiddleware
